module.exports = __webpack_public_path__ + "img/scheduling_type.a31d5528.svg";